import React, { Component } from 'react';
import TableParent from '../commonComponents/TableParent';
import CallAPI from '../commonComponents/AxiosHelper';
import LoadingComponent from '../commonComponents/LoadingComponent';
import Form from '../commonComponents/Form.v2';
import * as csv from 'csvtojson';
import { connect } from 'react-redux';
import { setTableData } from '../../action/index';
import { bindActionCreators } from 'redux';
import ErrorComponent from '../commonComponents/ErrorComponent';
// import SearchSelect from '../commonComponents/SearchSelect';
import CheckboxList from '../commonComponents/CheckBoxList';
import DataOperate from './DataOperate';
import DataOverwrite from './DataOverwrite';
import sanitizeHtml from 'sanitize-html';


class DBManagementComponentOld extends Component {

    constructor(props) {
        super(props);

        this.state = {
            db_management: null,
            selectedTable: null,
            isProcessing: false,
            upload: { "title": "Upload Data", "button_name": "Upload", "type": 0 },
            operation:null,
            type: {
                "transaction": { "name": "Transaction", "value": "transaction", },
                "master": { "name": "Master", "value": "master" },
                "merge": { "name": "Merge", "value": "Merge" },
            },
            pipeline_status: {
                "0": { name: "Not Set", value: "0" },
                "2": { name: "In Active", value: "2" },
                "1": { name: "Active", value: "1" }
            },
            isDisplay: {
                "1": { name: "Show", value: "1" },
                "0": { name: "Hide", value: "0" },
                "2": { name: "Delete", value: "2" }
            },
            action:"create"

        };

        this.formData = {

            "name": { "name": "tableName", "label": "Table Name", "type": "text", "requiredFlag": true },
            "type": {
                "name": "type", "label": "Table Type", "type": "dropdown", "options": [
                    { "name": "Select Option", "value": "" },
                    { "name": "Master", "value": "master", },
                    { "name": "Transaction", "value": "transaction" },
                ], "requiredFlag": true
            },
            "dataset": {
                "name": "dataset", "label": "Data", "type": "file","id":"createFile", "requiredFlag": true
            }
        }


        this.headerMapping = {
            "name": "Name",
            "isDerived": "Metric Type",
            "formula": "Formulae",
            "defaultFormula": "Aggregation Type",
            "isDisplay": "Display"
        }
        this.buttons = {
            "addButton": [{ "id": "addButton", "label": "Upload Data", "type": "normal", "display": true, "action": "add", 'modal_id': "#addContent" }],
            "dropdownConfig": [{
                "id": "id", "label": "More", "type": "dropdown", "display": true,
                "children": [
                    // { "id": "fileFormat", "label": "File Format Download", "action": "file" },
                    { "id": "exportCSV", "label": "Export CSV", "action": "export" },
                    // { "id": "importCSV", "label": "Import CSV", "action": "import" },
                ]
            }],
            "custom": [[{ "id": "gridView", "label": "Grid View", "type": "normal", "display": true, "link": "/admin/upload_data_new", "position": "left" }]]
            // "editButton": [{ "id": "editButton", "class": "", "label": "Edit", "type": "normal", "display": false, "action": "edit", 'modal_id': null }],
            // "saveButton": [{
            //     "id": "saveButton", "class": "", "label": "Save", "type": "normal", "display": false, "action": "save", 'modal_id': null
            // }],
            // "cancelButton": [{ "id": "cancelButton", "class": "", "label": "Cancel", "type": "normal", "display": false, "action": "cancel", 'modal_id': null }],
        }


        this.saveHandle = this.saveHandle.bind(this);
        this.change_table_format = this.change_table_format.bind(this);
        this.handleDataUpdate = this.handleDataUpdate.bind(this);
        this.fetchTableData = this.fetchTableData.bind(this);
        this.uploadDataConfig = this.uploadDataConfig.bind(this);
        this.viewRawData = this.viewRawData.bind(this);
        this.viewLogData = this.viewLogData.bind(this);
        this.makeAsDataset = this.makeAsDataset.bind(this);
        this.viewSummaryData = this.viewSummaryData.bind(this);
        this.handleSummaryConfig = this.handleSummaryConfig.bind(this);
        this.setSummaryData = this.setSummaryData.bind(this);
        this.controlPanel = this.controlPanel.bind(this);
        this.handleOperation = this.handleOperation.bind(this);
        this.handleErrorMessage = this.handleErrorMessage.bind(this);
        this.handleSidebarAction = this.handleSidebarAction.bind(this);

    }

    componentWillMount() {
        if (this.state.db_management == null || this.state.db_management == undefined){
            this.fetchTableData();
        }
    }

    componentDidUpdate(prevProps, nextState) {
        jQuery(".custom-file-input").on("change", function () {
            var fileName = jQuery(this).val().split("\\").pop();
            jQuery(this).siblings(".custom-file-label").addClass("selected").html(fileName);
        });

        if(this.state.selectedTable !== null){
            gridOptions.api.ensureNodeVisible(this.state.selectedTable['rowIndex']);
            gridOptions.api.getRowNode(this.state.selectedTable.id).setSelected(true);	
        }
    }

    fetchTableData(refresh = false) {
        let that = this;
        // that.setState({
        //     db_management: null
        // });
        let params = {
            siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
        }
        if (refresh == true) {
            params['refresh'] = true;
        }
        CallAPI('get', '/app/getdbManagement', null, params, 0, function (response) {
            that.props.setTableData(response.data);
            that.setState({ db_management: response});
        },this.props.authData)
    }


    componentDidMount() {
        jQuery(".custom-file-input").on("change", function () {
            var fileName = jQuery(this).val().split("\\").pop();
            jQuery(this).siblings(".custom-file-label").addClass("selected").html(fileName);
        });
    }

    // formats the headers from json data from backend to render in ag-grid
    change_table_format(array_data) {
        try {
            var that = this;
            let temp_array = [];
            array_data.map(function (innerData, index) {

                let inner_temp_array = [];

                inner_temp_array.label = innerData.tableName;
                // inner_temp_array.label = innerData.last_updated_time;
                inner_temp_array.name = innerData.tableName;
                inner_temp_array.raw_table = innerData.raw_table;
                inner_temp_array.file_names = innerData.file_names;
                inner_temp_array.date_information = innerData.date_information;
                inner_temp_array.db_mangement_id = innerData.id;
                // inner_temp_array.pipeline_status = innerData.pipeline_status ? that.state.pipeline_status[innerData.pipeline_status].name : innerData[that.headerMapping['isDerived']];

                inner_temp_array.last_updated_time = innerData.last_updated_time;
                inner_temp_array.new_inserted_rows = innerData.new_inserted_rows;
                inner_temp_array.tableName = innerData.tableName;
                inner_temp_array.table_size = innerData.table_size;
                inner_temp_array.total_cols = innerData.total_cols;
                inner_temp_array.total_rows = innerData.total_rows;
                inner_temp_array.new_inserted_rows = innerData.new_inserted_rows;
                inner_temp_array.type = innerData.type ? that.state.type[(innerData.type).toLowerCase()].name : innerData[that.headerMapping['isDerived']];

                inner_temp_array.updated_by = innerData.updated_by;
                inner_temp_array.summary = innerData.file_summary_validation;
                temp_array.push(inner_temp_array);
            })

            return { data: temp_array };
        }
        catch (e) {
            return "error";
        }
    }

    makeAsDataset(form) {
        let that = this;
        if (form.dataset_name == null || form.dataset_name == undefined || form.dataset_name == "") {
            alert("Dataset Name cannot be null");
        }
        else {
            form['dataset_name'] = form['dataset_name'].trim();
            form['tableName'] = this.state.selectedTable.tableName;
            let params = {
                siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
                email: this.props.authData.username,
            }
            this.setState({
                isProcessing: true
            });
            CallAPI('POST', '/app/make_dataset', form, params, 0, function (response) {
                alert(response.information);
                that.setState({
                    isProcessing: false
                });

                if (response.status) {
                    // window.location.reload();
                }
                that.fetchTableData();
                // jQuery('#customFile')[0].files = null;
                jQuery('#addContent').modal('hide');
                jQuery('#add_form').trigger("reset");

            },this.props.authData);
        }
    }



    handleDataUpdate(data) {
        let metric = this.state.metric;
        metric.metric = data;
        this.setState({
            metric: metric
        })
    }


    uploadDataConfig(name = null) {

        var selectedTableParams = (gridOptions.api.getSelectedNodes())[0]['data'];
        selectedTableParams.rowIndex = (gridOptions.api.getSelectedNodes())[0]['rowIndex'];
        selectedTableParams.id = (gridOptions.api.getSelectedNodes())[0]['id'];
        const that = this;

        if (name == "append") {
            this.setState({
                // upload: { "title": "Append Data", "button_name": "Append", "type": 1 },
                action:name,
                selectedTable: selectedTableParams
            });
            this.controlPanel(1, null);

        }
        else if (name == "overwrite") {

            let url = '/app/getOverwriteData';
            let params = {
                siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
                db_mangement_id: selectedTableParams.db_mangement_id,
                email: this.props.authData.username
            }

            CallAPI('get', url, null, params, 0, function (response) {
                selectedTableParams.file_names = response.information.file_names;
                selectedTableParams.date_information = response.information.date_information;
                that.setState({
                    action: name,
                    selectedTable: selectedTableParams
                });
                that.controlPanel(1, null);            
            },this.props.authData)
        }
        else if (name == "makeDataset") {
            this.setState({
                upload: { "title": "Make As Dataset", "button_name": "Update", "type": 3 },
                selectedTable: selectedTableParams,
                action:name
            });
            jQuery("#addContent").modal('show');

        }
    }

    saveHandle(e, uploadType = null) {
        let form_array = jQuery("#add_form").serializeArray();
        let form_params = {};
        let file = null;

        form_array.map((element, i) => {
            form_params[element['name']] = sanitizeHtml(element['value']);
        });

        if (form_params['tableName'] == null || form_params['tableName'] == undefined || form_params['tableName'] == "" ){
            form_params['tableName'] = sanitizeHtml(this.state.selectedTable.tableName);
        }

        
        switch (this.state.action) {
            case "create":
                form_params['action'] = "create"
                break;
            case "append":
                form_params['action'] = "append"
                break;
            case "overwrite":
                form_params['action'] = "overwrite"
                break;
            default:
                break;
        }


        if(this.state.action == "makeDataset"){
            this.makeAsDataset(form_params); 
        }
        else{
            var formData = new FormData();


            if(form_params['action'] == "create"){
                file = jQuery('#createFile')[0].files[0];

            }

            if (form_params['action'] == "overwrite" || form_params['action'] == "append"){

                file = jQuery("#operateFile")[0].files[0]
            }
            

            if (file !== null && file !== undefined) {
                if (this.state.action == "create" && (form_params['tableName'] == "" || form_params['type'] == "makeDataset")) {
                    alert("Please Provide Table Name and Type!");
                }
                else if (this.state.action == "overwrite" && !this.refs.dataOverwrite.state.checkSubmit){
                        alert("Please provide the proper case for overwrite!");
                }
                else {

                    let that = this;
                    let params = {
                        siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
                        toolId: that.props.datasetValue,
                        email: this.props.authData.username,
                    }

                    formData.append('tableName', sanitizeHtml(form_params['tableName']));
                    formData.append('uploadedfile', file);
                    formData.append('action', sanitizeHtml(form_params['action']));

                    if(this.state.action == "create"){
                        formData.append('type', sanitizeHtml(form_params['type']));
                    }

                    if (this.state.action == "overwrite") {
                        const overwriteState = this.refs.dataOverwrite.state;
                        let overwriteCase = overwriteState.condition[overwriteState.overwriteAction];
                        formData.append('overwrite', JSON.stringify(overwriteCase));
                    }

                    that.setState({
                        isProcessing: true
                    })

                    

                    CallAPI('POST', '/app/uploadCSV', formData, params, 1, function (response) {
                        jQuery('#addContent').modal('hide');
                        jQuery('#add_form').trigger("reset");
                        if(!response.status){
                            let errorObj = that.handleErrorMessage(response);
                            alert(errorObj.message);
                            if(errorObj.type == "mapError"){
                                let operation = {};
                                operation.tableName = form_params['tableName'];
                                operation.file = file;
                                operation.info = response;
                                if(that.state.action == "overwrite"){
                                    let overwriteCase = that.refs.dataOverwrite.state.condition[that.refs.dataOverwrite.state.overwriteAction]
                                    operation.overwriteParams = overwriteCase;
                                }
                                jQuery(".addRow").html(`Submit`);
                                jQuery(".addRow").prop(`disabled`,false);
                                that.setState({
                                    operation: operation,
                                    action:"create"
                                });
                            }   
                        }
                        else{
                            alert("Successfully Uploaded!");
                            that.controlPanel(null, null, 'close');
                            that.setState({
                                isProcessing:false
                            })
                        }
                        // that.fetchTableData();
                    },this.props.authData);
                }
            }
            else if (file == null) {
                alert("File is mandatory!");
            }
        }
        e.preventDefault();
    }


    viewRawData() {

        let selectedTable = (gridOptions.api.getSelectedNodes())[0]['data']['tableName'];

        let pathname = '/admin/raw_data';
        let search = `?raw_data=${selectedTable}&tableFlag=0`;
        let url = `${pathname}${search}`;

        var win = window.open(url, '_blank');
    }


    viewLogData() {

        let selectedTable = (gridOptions.api.getSelectedNodes())[0]['data']['raw_table'];
        let pathname = '/admin/logs';
        let search = `?tableName=${selectedTable}`;
        let url = `${pathname}${search}`;

        var win = window.open(url, '_blank');
    }

    handleSummaryConfig(data){
        let modal_form_state = this.state.upload;
        modal_form_state.tableSummary = data

        this.setState({
            upload: modal_form_state
        })
    }

    viewSummaryData() {
        let selectedNode = (gridOptions.api.getSelectedNodes())[0]['data']['summary'];
        var selectedTableParams = (gridOptions.api.getSelectedNodes())[0]['data'];
        selectedTableParams.rowIndex = (gridOptions.api.getSelectedNodes())[0]['rowIndex'];
        selectedTableParams.id = (gridOptions.api.getSelectedNodes())[0]['id'];

        // let selectedTable = (gridOptions.api.getSelectedNodes())[0]['data']['raw_table'];
        let modal_form_state = this.state.upload;
        // modal_form_state.tableSummary = selectedNode;
        if (selectedNode !== null && selectedNode !== null){
            modal_form_state.tableSummary = JSON.parse(selectedNode);
        }

        this.setState({
            upload: modal_form_state,
            selectedTable: selectedTableParams
        });
        jQuery("#updateModal").modal('toggle');

    }

  

    setSummaryData(){
        let that = this;
        let params = {
            "siteId": localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
            "email": this.props.authData.username,
        };

        let data = {
            "tableName": this.state.selectedTable.raw_table,
            "columns": this.state.upload.tableSummary
        };

        CallAPI('post', '/app/set_file_validate_columns', data, params, 0, function (response) {
            if (response.status) {
                jQuery("#updateModal").modal('toggle');
                alert("Log summary updated");
                that.fetchTableData();
                that.setState({
                    columns:null
                })
            }
            else{
                alert(response.information);
            }
        },this.props.authData);
    }

 
    controlPanel(index,e = null,action=null) {
        let defaultClass = "off-canvas off-canvas-push off-canvas-right wd-500";
        let openClass = defaultClass + ' show';
        if (index !== null) {
            jQuery("#mappingPane").removeClass(defaultClass);
            jQuery("#mappingPane").addClass(openClass);
        }

        if (index == null && ( action =='close' || e.target.id=="closeButton" )) {
            if(e !== null){
                e.preventDefault();
            }
            jQuery("#mappingPane").removeClass(openClass);
            jQuery("#mappingPane").addClass(defaultClass);
            // if (this.state.action == "append") {    
                this.setState({
                    action:"create",
                    operation:null,
                    selectedTable: null
                })
            // }

            // if (this.state.action == "overwrite") {
                // this.setState({
                //     selectedTable:null
                // })
            // }

        }
    }

    handleOperation(){
        const operationInfo = this.state.operation;
        var mapping = {};
        var extraColumnsArray = [];
        var ignoreColumnsArray = {};
        var defaultArray = [];
        const operationMapping = this.refs.dataOperation.state.data.mapping;
        const extra_columns = this.state.operation.info.extra_columns;
        for (const key in operationMapping) {
            if (operationMapping.hasOwnProperty(key)) {
                let element = operationMapping[key];
                if(element == "add"){
                    mapping[key] = key;
                    extraColumnsArray.push(key);

                }
                else if(element == "ignore"){
                    if (extra_columns.file !== null && extra_columns.file !== undefined && extra_columns.file.length !== 0){
                        if (extra_columns.file.indexOf(key) !== -1){
                            mapping[key] = key;
                            if (ignoreColumnsArray.file == null || ignoreColumnsArray.file == undefined){
                                ignoreColumnsArray.file = key;
                            }
                            else{
                                ignoreColumnsArray.file = `${ignoreColumnsArray.file},${key}` ;
                            }
                        }
                    }
                    
                    if (this.state.operation.info.database_columns.indexOf(key) !== -1) {
                        if (ignoreColumnsArray.db == null || ignoreColumnsArray.db == undefined) {
                                ignoreColumnsArray.db = key;
                        }
                        else{
                            ignoreColumnsArray.db = `${ignoreColumnsArray.db},${key}`;
                        }
                    }
                    
                    // ignoreColumnsArray.push(key);
                }
                else if(element == "default"){
                    defaultArray.push(key);
                }
                else{
                    mapping[key] = element;
                }   
            }
        }

        if (extra_columns.db !== null && extra_columns.db !== undefined && extra_columns.db.length !== 0){
            let ignoreMissing = extra_columns.db.join();
            if (ignoreMissing.db == null || ignoreMissing.db == undefined){
                ignoreColumnsArray.db = ignoreMissing;
            }
            else{
                ignoreColumnsArray.db = `${ignoreColumnsArray.db},${ignoreMissing}`;
            }
        }

        const that = this;
        let params = {
            siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
            email: this.props.authData.username,
        }

        var formData = new FormData();
        formData.append('tableName', operationInfo['tableName']);
        formData.append('mapping', JSON.stringify(mapping));
        formData.append('uploadedfile', operationInfo['file']);
        formData.append('action', operationInfo.info['action']);

        if(operationInfo.info['action'] == "overwrite"){
            formData.append('overwrite', JSON.stringify(operationInfo.overwriteParams));
        }


        if(extraColumnsArray.length !== 0){
            let extraColumnsList = extraColumnsArray.join();
            formData.append('new_column', extraColumnsList);
        }


        if (ignoreColumnsArray.length !== 0){
            // let ignoreColumnsList = ignoreColumnsArray.join();
            formData.append('ignore_columns', JSON.stringify(ignoreColumnsArray));
        }

        if(defaultArray.length !== 0){
            let message = 'Please map the following columns:\n';
            for (let i = 0; i < defaultArray.length; i++) {
                message += `${i + 1}.${defaultArray[i]}.\n`;
            }
            alert(message);
        }
        else{
            this.setState({
                isProcessing:true
            })
            CallAPI('POST', '/app/uploadCSV', formData, params, 0, function (response) {
                let information = response.information;
                if (response.status) {
                    alert(information);
                    that.setState({
                        isProcessing: false,
                        operation: null
                    });
                    that.controlPanel(null, null, 'close');
                    that.fetchTableData();
                }
                else {
                    let errorObj = that.handleErrorMessage(response);
                    alert(errorObj.message);
                    // alert('Operation failed');
                }                               
            },this.props.authData);
        }

    }

    handleErrorMessage(obj){
      
        var errorObj = {
            "message":null,
            "type":null
        }

        var error_info = '';
        if (obj.extra_columns !== null && obj.extra_columns !== undefined ){
            if (obj.extra_columns.file !== undefined && obj.extra_columns.file !== null){
                if(obj.extra_columns.file.length !== 0){
                    error_info = 'Extra columns found:\n';
                    for (let i = 0; i < obj.extra_columns.file.length; i++) {
                        error_info += `${i + 1}.${obj.extra_columns.file[i]}.\n`;
                    }
                }
            }
            if (obj.extra_columns.db !== undefined && obj.extra_columns.db !== null) {
                if (obj.extra_columns.db.length !== 0) {
                    error_info = `${error_info}\nMissing Columns found:\n`;
                    for (let i = 0; i < obj.extra_columns.db.length; i++) {
                        error_info += `${i + 1}.${obj.extra_columns.db[i]}.\n`;
                    }
                }
            }
            errorObj.message = error_info
            errorObj.type = "mapError"
        }

        if (obj.tableName !== null && obj.tableName !== undefined){
            errorObj.message = obj.information;
        }

        return errorObj;
    
    }

    handleSidebarAction(){
        // if(this.state.action == "append" || this.state.action == "overwrite"){
        // }
        
        if(this.state.operation !== null){
            return this.handleOperation;
        }
        else{
            return this.saveHandle;
        }
    }


    render() {

        let that = this;
        const sidebarAction = this.handleSidebarAction();

        // listens for the event when modal is closed and resets the title and button for #addContent Modal
        jQuery('#addContent').on('hidden.bs.modal', function (e) {
            if (that.state.upload.type !== 0) {
                that.setState({
                    upload: { "title": "Upload Data", "button_name": "Upload", "type": 0 }
                })
            }
        });
        var mainData = <LoadingComponent />;
        var panelComponent = null;


        if (this.state.db_management) {
            let final_data = this.change_table_format(this.state.db_management.data);

            if (final_data !== "error") {
                let type = Object.values(this.state.type).map(function (value) {
                    return value.name;
                });

          

                var columns_array = [
                    { label: "Table Type", value: "type", type: "html", dropdown_value: type, editable: false, dataType:'string', hide: false },

                    { label: "Total Rows", value: "total_rows", type: "number", editable: false, dataType: 'number', hide: false },
                    { label: "Total Columns", value: "total_cols", type: "number", editable: false, dataType: 'number', hide: false },
                    { label: "Last Updated Rows", value: "new_inserted_rows", type: "number", editable: false, dataType: 'number', hide: true },
                    // { label: "Raw Table", value: "raw_table", type: "html", editable: false },
                    // { label: "Pipeline Status", value: "pipeline_status", type: "html", dropdown_value: pipeline_status, editable: true, dataType: 'string', hide: false },
                    { label: "Last Updated Time", value: "last_updated_time", type: "datetime", editable: false, hide: true, dataType: 'string' },
                    { label: "Updated By", value: "updated_by", type: "string", editable: false, hide: true, dataType: 'string' }
                ];


                var firstColumn = "Name";             

                let makeDatasetForm = {
                    "dataset": {
                        "name": "dataset_name", "label": "Dataset Name", "type": "text"
                    }
                }

                var Form_Data = <Form label_array={this.formData} call_back={this.call_back_form} />;


                var searchSelectBody = null;
                if (this.state.upload.tableSummary !== null &&  this.state.upload.tableSummary !== undefined) {
                    let summaryObj = this.state.upload.tableSummary;
                    let config = {
                        "data": summaryObj,
                        "selectedTable":this.state.selectedTable
                    }
                    searchSelectBody = <CheckboxList config={config} getData={this.handleSummaryConfig}/>;
                }
                else{
                    searchSelectBody = <div>No summary columns found for this table</div>;
                }


                if (this.state.action == "makeDataset") {
                    Form_Data = <Form label_array={makeDatasetForm} call_back={this.call_back_form} />;
                }

                
                var modals = {
                    "updateModal": {
                        "form_name": "summary_form", "title": "Set Summary Data", "body": searchSelectBody, "button_name": "Configure Summary", "action": "update", "display": true
                    },
                    "addModal": {
                        "form_name": "add_form", "title": this.state.upload['title'], "body": Form_Data, "button_name": this.state.upload['button_name'], "action": "add", buttonType:"submit", "display": true, "isLoading": this.state.isProcessing, "buttonId": "uploadFile"
                    }
                }



                // For extra Context Menu Options, seperate instantiations to be defined and called,
                // for the Dataset Page ,the folowing config is passed
                var customMenu = {
                    "actions": {
                        "name": "actions", "label": "Actions", "action": null,
                        "items": {
                            "viewData": { "name": "viewData", "label": "View Raw Data", "action": this.viewRawData },
                            "makeDataset": { "name": "makeDataset", "label": "Make as Dataset", "action": this.uploadDataConfig },
                            "append": { "name": "append", "label": "Append Data", "action": this.uploadDataConfig },
                            "overwrite": { "name": "overwrite", "label": "Overwrite Data", "action": this.uploadDataConfig },
                            "viewLogs": { "name": "viewLogs", "label": "View Logs", "action": this.viewLogData },
                            "setSummary": { "name": "setSummary", "label": "Set Log Summary", "action": this.viewSummaryData },
                        }
                    }
                }

                mainData = (<><TableParent
                    data={final_data}
                    parentConfig={this.state}
                    columns_array={columns_array}
                    firstColumn={firstColumn}
                    // editData={this.state.metric.metric}
                    modalConfig={modals}
                    onCellChange={this.change_handle}
                    filename="Uploaded File List"
                    // actionArray={this.props.menuData}
                    menuAction={this.handleMenuAction}
                    handleDataUpdate={this.handleDataUpdate}
                    saveHandle={this.saveHandle}
                    buttonConfig={this.buttons}
                    submitHandle={this.submitHandle}
                    importJSON={this.text_to_json}
                    customMenu={customMenu}
                    rowSelection="single"
                    page="uploadTable"
                    updateModalAction={this.setSummaryData}
                />
                </>)
            }
            else {
                mainData = <ErrorComponent />;
            }

            var sidebarButton = (<button onClick={sidebarAction} className="btn btn-sm btn-primary float-right mg-x-20 mg-y-10">Submit</button>)


            if(this.state.operation !== null){
                panelComponent = <DataOperate ref={"dataOperation"} data={this.state.operation} />
            }
            else{
                if(this.state.action == "append"){
                    let formData = {
                        "dataset":
                        {
                            "name": "dataset", "label": "Data", "type": "file",id:"operateFile"
                        }
                    };
                    panelComponent = <Form label_array={formData} call_back={this.call_back_form} />;

                }

                if (this.state.action == "overwrite") {
                    panelComponent = <DataOverwrite ref="dataOverwrite" data={this.state.selectedTable} />
                }
            }           
        }

   
        if(this.state.isProcessing){
            sidebarButton = (<button className="btn btn-sm btn-primary mg-x-20 mg-y-10 float-right addRow" type="button" disabled>
                <span className="spinner-border spinner-border-sm mg-x-5" role="status" aria-hidden="true"></span>
                <span if="file_loading_percentage">0</span>
                Loading Data...
            </button>);
        }
      



        return (
            <div className="">
                {/* <DatasetFilter /> */}
                {/* <div><a id={`pane_${1}`} style={{ cursor: "pointer" }} href="javascript:void(0)" onClick={this.controlPanel.bind('index', 1)}>View More</a></div> */}

                {mainData}
                    <div id="mappingPane" className="off-canvas off-canvas-push off-canvas-right wd-500">
                        <header className="off-canvas-header">
                            <span>Map Columns</span>
                            <a id="closeButton" className="close float-right" style={{ cursor: "pointer" }} href="javascript:void(0)" onClick={this.controlPanel.bind('index', null)}>x</a>
                        </header>
                        {/* <a id="" href="#" className="close">close</a> */}
                        <div className="off-canvas-content">
                        <div className="pd-15" style={{ "overflowY": "scroll", "height": "400px" }}>
                            {panelComponent}
                            </div>
                        </div>
                    {/* <footer className="footer bd-t"> */}
                    <div className="customfooter">
                       {sidebarButton}
                    </div>
                    </div>
                </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        tableData: state.dataSet.tableData,
        authData: state.dataSet.authData
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setTableData
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(DBManagementComponentOld);